// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"PageLayout_pageLayout__3Fo31","contentWrap":"PageLayout_contentWrap__1UDId","fullVideo":"PageLayout_fullVideo__2tgdG","fullWidth":"PageLayout_fullWidth__G4Yxq"};